/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Actions from './Actions/index'
import AgGrid from 'DesignSystem/AgGrid/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Financial/Content/Statements/Old/Data/Content",
  columnDefs
  
}) {
let statementsValueData = fromData.useDataValue({ viewPath,
context: 'statements',
})
let onSelectionChanged = fromHelpers.useOnChangeSelectedRows({
  children,
  viewPath,
  columnDefs
  
})
  return (<React.Fragment
>
<AgGrid
  viewPath={`${viewPath}/AgGrid`}
 height="100%"
 columnDefs={columnDefs}
 data="statements"
 rowData={statementsValueData}
 rowGroupPanelShow="never"
 rowSelection="multiple"
 onSelectionChanged={onSelectionChanged}
/>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
{children}
</React.Fragment>)
}